import type { StatesConfig } from 'xstate'
import type { TStep } from 'src/types'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'
import { useZustandGlobalStore } from 'zustandGlobalStore'
import { PageId } from 'constants/pages'

export const getXStateConfigWoofzInt3 = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    always: [
      {
        target: getIntellioResumeTarget({
          pages,
          pageIds: {
            certificate: PageId.CERTIFICATE_INTL_3,
            nameEntry: PageId.NAME_ENTRY_INTL_3,
            offer: PageId.OFFER_INTL_3,
            registration: PageId.REGISTRATION_INTL_3,
            report: PageId.REPORT_INTL_3,
          },
        }),
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP: {
            target:
              index + 2 < pages.length
                ? pages[index + 2].pageId
                : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          POST_PAYMENT_CONTINUE: {
            target: PageId.REGISTRATION_INTL_3,
          },
          ...(page.pageId === PageId.EMAIL_INTL_3 && {
            PREVIOUS_FLOW_STEP: { target: PageId.DISCOVER_FEEDBACKS_INTL_3 },
          }),
          ...(page.pageId === PageId.OFFER_INTL_3 && {
            NEXT_FLOW_STEP: { target: PageId.PAYMENT_INTL_3 },
          }),
          ...(page.pageId === PageId.PAYMENT_INTL_3 && {
            PREVIOUS_FLOW_STEP: [
              {
                cond: (): boolean =>
                  !!useZustandGlobalStore.getState().hasVisitedCancelOfferIntl3,
                target: PageId.CANCEL_OFFER_INTL_3,
              },
              { target: PageId.SPECIAL_DISCOUNT_INTL_3 },
            ],
          }),
        },
      },
    }),
    {},
  ),
  // [PageId.DOWNLOAD_ESA_INTL_3]: {
  //   type: 'final',
  // },
})
